export default {
  appName: 'gxxt',
  qqMapKey: 'FLGBZ-M2PKW-BH5R3-RP62V-NFF25-KKBLS',
  hostname: location.protocol + '//' + location.host,
  goodsNames: ['课程', '训练营', '私教坊', '专栏', '会员VIP'],
  iosAppLink: 'itms-apps://itunes.apple.com/cn/app/id1531853722?mt=8',
  goodsType: {
    'course': 0, //轻课
    'training': 1,
    'offlineClass': 2,
    'column': 3,
    'vip': 4
  },
  // 训练营报名状态
  trainCampStatus: {
    'toBeRegistered': 0, //待报名
    'registrationInProgress': 1, //报名中,
    'registrationIsClosed': 2, //报名已截止,
    'closed': 3,//已结课
  },
  offlineClassStatus: {
    'toBeRegistered': 0, //'未发布',
    'registrationInProgress': 1,//'报名中',
    'sellOut': 2,//'已售罄',
    'closed': 3,//'已结束',
    'registrationIsClosed': 4,//'报名已截止',
  },
  logo: 'https://media.bijixia.net/image/default/87DE0CF7A0D24BEB93D4F50D134E198F-6-2.png',
  // 课程媒体类型 0:图片,1:音频,2:视频
  materialType: {
    text: 0,
    audio: 1,
    video: 2,
  },
  articleType: ['图文', '音频', '视频',],
  orderStatus: ['待付款', '已取消', '已付款', '已完成', '订单异常'],
  couponType: ['训练营抵扣券', '私教坊抵扣券', '满减券'],
  service: "https://work.weixin.qq.com/kfid/kfc3c6901ae0205affb?enc_scene=ENC9r7v1PSzjS7Qnfg4yLk5B61QtehMtgXJyGe53Cz6YxZAVBviQR94JVbfkmaS6qUtpL",
  h5CatsAtHome: ['选对人', '用好人', '育成人', '留住人'],
  gradeType: ['图片', '音频', '视频', '随堂检测', '作业']
}